/** @format */
import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { CustomModuleAttainment } from 'common-typescript/types';
import { CustomModuleAttainmentStateObject } from '../../service/plan-state.service';
import { PlanStructureContext } from '../plan-structure-context';
import { getFudisHeadingSize } from '../plan-structure-utils';

@Component({
    selector: 'sis-plan-structure-custom-module-attainment',
    templateUrl: './plan-structure-custom-module-attainment.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlanStructureCustomModuleAttainmentComponent {
    readonly customModuleAttainment = input.required<CustomModuleAttainment>();
    readonly headingLevel = input.required<number>();

    private readonly planStructureContext = inject(PlanStructureContext);

    protected readonly customModuleAttainmentStateObject = computed<CustomModuleAttainmentStateObject | undefined>(
        () => this.planStructureContext.planStateObject().customModuleAttainments?.[this.customModuleAttainment()?.id],
    );

    getHeadingSize() {
        return getFudisHeadingSize(this.headingLevel());
    }

    useBackgroundColor() {
        const customModuleAttainmentStateObject = this.customModuleAttainmentStateObject();
        return (
            (customModuleAttainmentStateObject.selectedCourseUnitIds?.length > 0 ||
                customModuleAttainmentStateObject?.selectedCustomCourseUnitAttainmentIds?.length > 0) &&
            this.customModuleAttainment().nodes.filter(node => node.type !== 'AttainmentGroupNode').length > 0
        );
    }
}
